// import 'whatwg-fetch';
import { createAction } from 'redux-actions';
import AuthDevise from '../utils/AuthDevise/AuthDevise'

export const loginAction = createAction('AUTH_START', AuthDevise.login);
export const logoutAction = createAction('START_LOGOUT', AuthDevise.logout);
export const setUserTokenAction = createAction('SET_USER_TOKEN');
export const checkAuthAction = createAction('CHECK_AUTH', AuthDevise.checkAuth);


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/deviseAction.jsx